import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { TrustpilotWidgetComponent } from '@df/module-trustpilot/trustpilot-widget.component';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../product.decorator';

@Component({
    selector: 'product-plp-trustpilot-reviews',
    imports: [TrustpilotWidgetComponent],
    templateUrl: 'product-plp-trustpilot-reviews.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPlpTrustpilotReviewsComponent extends UiComponent {
    readonly product = input.required<Product<IProductDataV2>>();

    protected readonly config = computed(() => this.product().plpTrustpilotReviewsConfigData?.content);
    protected readonly sku = computed(() => this.product().getTrustpilotSkus());
}
